<template>
  <div id="financial-profile-items" class="bg-wht">
    <div class="row">
      <div class="col-xs-12">
        <div>
          <loader v-if="loading"/>
          <div v-else>
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <label for="name" class="form-label">Name</label>
                <input id="name" type="text" class="form-control" v-model="entity.name"/>
              </div>
              <div class="form-group">
                <label for="financial-code" class="form-label">Financial Code</label>
                <select v-model="entity.financialCode" class="form-control" id="financial-code">
                  <option value=""></option>
                  <option v-for="option in financialCodes" :value="option.id">{{ option.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="service-type" class="form-label">Service type</label>
                <select v-model="entity.serviceType" class="form-control" id="service-type">
                  <option value=""></option>
                  <option v-for="option in serviceTypes" :value="option.id">{{ option.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="currency" class="form-label">Currency</label>
                <select v-model="entity.currency" class="form-control" id="currency">
                  <option value=""></option>
                  <option v-for="option in currencies" :value="option.id">{{ option.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="calculation" class="form-label">Calculation</label>
                <select v-model="entity.calculation" class="form-control" id="calculation">
                  <option value=""></option>
                  <option v-for="option in calculations" :value="option.id">{{ option.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="exc" class="form-label">Exchange Rate</label>
                <input id="exc" type="number" class="form-control" step="0.01" v-model="entity.exchangeRate"/>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <label for="markup" class="form-label">Markup Type</label>
                <select v-model="entity.markupType" class="form-control" id="markup">
                  <option value=""></option>
                  <option v-for="option in markups" :value="option.value">{{ option.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="markup-by" class="form-label">Markup by</label>
                <input id="markup-by" type="number" class="form-control" step="0.01" v-model="entity.markupBy"/>
              </div>
              <div class="form-group">
                <label for="source" class="form-label">Source</label>
                <select v-model="entity.source" class="form-control" id="source">
                  <option value=""></option>
                  <option v-for="option in sources" :value="option.value">{{ option.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="subtotal" class="form-label">Sub Total</label>
                <select v-model="entity.subtotal" class="form-control" id="subtotal">
                  <option value=""></option>
                  <option v-for="option in subtotals" :value="option">{{ option }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="total-type" class="form-label">Total Type</label>
                <select v-model="entity.totalType" class="form-control" id="total-type">
                  <option value=""></option>
                  <option v-for="option in totalTypes" :value="option.value">{{ option.name }}</option>
                </select>
              </div>
              <div class="pull-right" style="margin-top:26px;">
                <div class="btn btn-success sq" @click="save">
                  Save
                </div>
                <div class="btn btn-danger sq" @click="reset">
                  Clear
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading">
      <vue-table
        :tableData="items"
        :fields="itemFields"
        :show-edit="true"
        :show-delete="true"
        @table-edit-request="edit"
        @table-delete-request="remove"
      />
    </div>
  </div>
</template>
<script>
import api from '../../../../api/endpoints'
import event from '../../../../event'
import Mixin from './Mixin'
import Loader from '../../../helpers/Loader'
import VueTable from '../../../helpers/VueTable'
export default {
  name: 'FinancialProfileItems',
  mixins: [ Mixin ],
  components: { Loader, VueTable },
  props: {
    parentId: {
      type: Number,
      required: true
    },
    category: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      items: [],
      entity: {
        id: null,
        financeProfile: null,
        category: null,
        currency: null,
        financialCode: null,
        calculation: null,
        exchangeRate: 0,
        markupType: null,
        markupBy: 0,
        name: null,
        serviceType: null,
        source: null,
        subtotal: null,
        totalType: null
      },
      loading: true,
      itemFields: [
        { header: 'Name', prop: 'name' },
        { header: 'Financial Code', prop: this.getFinancialCodeObject }
      ],
      entityName: 'financial-profile-item'
    }
  },
  computed: {
    financialCodes () {
      return this.$store.getters['systemOption/financialCodes']
    },
    serviceTypes () {
      return this.$store.getters['systemOption/serviceTypes']
    },
    currencies () {
      return this.$store.getters['systemOption/currencies']
    },
    calculations () {
      return this.$store.getters['systemOption/calculations']
    }
  },
  methods: {
    reset () {
      this.entity = {
        id: null,
        financeProfile: null,
        category: null,
        currency: null,
        financialCode: null,
        calculation: null,
        exchangeRate: 0,
        markupType: null,
        markupBy: 0,
        name: null,
        serviceType: null,
        source: null,
        subtotal: null,
        totalType: null
      }
    },
    edit ({ item }) {
      this.entity = item
    },
    remove ({ item }) {
      this.$http.delete(api.DELETE_ADMIN_ENTITY(this.entityName, item.id))
        .then(() => this.removeFromTable(item.id))
        .catch(console.log)
    },
    save () {
      const url = this.entity.id ? api.UPDATE_ADMIN_ENTITY(this.entityName, this.entity.id) : api.CREATE_ADMIN_ENTITY(this.entityName)
      const method = this.entity.id ? 'put' : 'post'
      this.$http[method](url, { ...this.entity, financeProfile: this.parentId, category: this.category })
        .then(({data}) => {
          data = this.unwrap(data)
          if (method === 'post') {
            this.items.push(data)
          } else {
            const item = this.items.find(({id}) => id === this.entity.id)
            if (item) {
              for (let prop in item) {
                item[prop] = data[prop]
              }
            }
          }
          this.reset()
        })
    },
    removeFromTable (_id) {
      const index = this.items.findIndex(({id}) => id === _id)
      if (index > -1) {
        this.items.splice(index, 1)
      }
    },
    getFinancialCodeObject ({financialCode}) {
      return (this.financialCodes.find(({id}) => id === financialCode) || {}).name
    },
    getItems () {
      if (this.parentId) {
        this.$http.get(api.GET_ENTITIES(this.entityName), { params: { financeProfile: this.parentId } })
          .then(({data}) => { this.items = this.unbox(data) })
          .catch(err => {
            console.log(err)
            event.$emit('toast', { type: 'error', message: 'Unable to Load Items' })
          }).then(() => { this.loading = false })
      }
    },
    unwrap (item) {
      return {
        ...item,
        financialCode: item.financialCode && item.financialCode.id,
        currency: item.currency && item.currency.id,
        calculation: item.calculation && item.calculation.id,
        serviceType: item.serviceType && item.serviceType.id
      }
    },
    unbox (arr) {
      return arr.map(this.unwrap)
    }
  },
  watch: {
    parentId: {
      handler: 'getItems',
      immediate: true
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/modules/admin/components/FinancialProfile/FinancialProfileItems.vue